
import { useEffect } from "react";

export const useGalleryKeyboard = (showGallery, setShowGallery, setGalleryIndex, imagesLength) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!showGallery) return;
      if (e.key === 'Escape') setShowGallery(false);
      if (e.key === 'ArrowLeft') setGalleryIndex(prev => (prev > 0 ? prev - 1 : imagesLength - 1));
      if (e.key === 'ArrowRight') setGalleryIndex(prev => (prev < imagesLength - 1 ? prev + 1 : 0));
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [showGallery, setShowGallery, setGalleryIndex, imagesLength]);
};
